import React, { useState, useEffect, useContext } from "react";
import "./pending.css";
// import Timer from "./timer";
import { useHistory, Redirect } from "react-router-dom";
import Cookies from "js-cookie";
import { firebase, firebaseFirestore } from "./firebase";
import Timer from "./timer";

const DeliveryPage = (props) => {
  let history = useHistory();

  useEffect(() => {
    if (props.location.state?.orderId === undefined) {
      history.push("/store");
    }
  }, []);

  useEffect(() => {
    // const query = firebaseFirestore.query(firebaseFirestore.collection(firebase.db, "orders"), firebaseFirestore.where('email', '==', user));
    const unsubscribe = firebaseFirestore.onSnapshot(
      firebaseFirestore.doc(firebase.db, "orders", props.location.state?.orderId),
      (snapshot) => {
        if (snapshot.exists()) {
          // console.log(snapshot.data());
          if ((Date.now() - (snapshot.data().timestamp*1000) > 120000) && snapshot.data().status === 'pending') {
            unsubscribe();
            firebaseFirestore.updateDoc(firebaseFirestore.doc(firebase.db, "orders", props.location.state?.orderId), { status: 'notfound' });
            alert('No delivery parnter found!!!')
            history.push("/account");
          }
          switch (snapshot.data().status) {
            case 'pending':
              console.log('pending');
              break;
            case 'accepted':
              unsubscribe();
              console.log('accepted');
              history.push("/chat", { orderId: props.location.state?.orderId, data: snapshot.data() });
              break;
            case 'delrejected':
              unsubscribe();
              firebaseFirestore.updateDoc(firebaseFirestore.doc(firebase.db, "orders", props.location.state?.orderId), { status: 'rejected' });
              console.log('delrejected');
              history.push("/account");
              break;
            default:
              history.push('/account')
              console.log('default');
          }
        }
        //   setOrders(snapshot.data());
        // }
        // snapshot.forEach((doc) => {;
        //   if (doc.exists()) {
        //     console.log(doc.data());
        //     if (userOrder) {
        //       let userOrder = order.find((e) => e.email == user);
        //       if (userOrder.status === "accepted") {
        //         history.push("/chat");
        //       } else if (userOrder.status === "rejected") {
        //         history.push("/rejected");
        //       }
        //     }
        //   } else {
        //     setOrders(null);
        //   }
      });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <div className="pending-container">
      <div className="pending-page-timer">
        <Timer duration={120} />
      </div>
      <div className="pending-text">
        <span>Waiting for DeliBuddies</span>
        <span>to accept your order</span>
      </div>
    </div>
  );
};

export default DeliveryPage;
